import moment from 'moment';
import { reduxForm } from 'redux-form';

import { Button, themes, ResetBtn } from 'libs/ui';
import { DateSelect, Container, DoubleField, DateTime, ButtonsContainer } from 'libs/form';

const FilterForm = (props) => {
  const { handleSubmit, reset, change } = props;

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <DateSelect from_name="datetime_from" to_name="datetime_to" change={change}>
          <DoubleField>
            <DateTime width="160px" name="datetime_from" type="dateTime" label="Дата и время" />
            <DateTime width="160px" name="datetime_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <ButtonsContainer>
          <ResetBtn onClick={reset} />
          <Button theme={themes.blue}>Скачать</Button>
        </ButtonsContainer>
      </form>
    </Container>
  );
};

const initialValues = {
  datetime_from: moment().startOf('day').format(),
  datetime_to: moment().endOf('day').format(),
};

export const Filter = reduxForm({
  form: 'summaryFilter',
  destroyOnUnmount: false,
  initialValues: initialValues,
})(FilterForm);
